export default {
  GET_COMMISSIONS (state, data) {
    state.commissions = data
  },
  GET_PROJECTS (state, data) {
    state.projects = data
  },
  GET_PROJECT (state, { type, post }) {
    state[type].push(post)
  },

  PAGE_LOADED (state, { slug, data }) {
    state.pages[slug] = data
  },

  TOGGLE_ZOOM_STATE (state, newVal) {
    state.imageZoomActive = newVal
  },

  READY (state) {
    state.ready = true
  },
  IMG_IS_READY (state, val) {
    state.imgReady = val
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js